export default {
    setColor(idPeriodo: number) {
        let color = '';
        switch (idPeriodo) {
            case 1:
                color = '#02C648';
                break;
            case 2:
                color = '#54C602';
                break;
            case 3:
                color = '#64C602';
                break;
            case 4:
                color = '#C1C602';
                break;
            case 5:
                color = '#C6A102';
                break;
            case 6:
                color = '#C67202';
                break;
            case 7:
                color = '#C63A02';
                break;
            case 8:
                color = '#C60202';
                break;
            case 50:
                color = 'primary';
                break;
        }
        return color;
    },
    setIcon(idPeriodo: number) {
        let icon = '';
        switch (idPeriodo) {
            case 1:
                icon = 'mdi-forklift';
                break;
            case 2:
                icon = 'mdi-vector-square';
                break;
            case 3:
                icon = 'mdi-file-chart';
                break;
            case 4:
                icon = 'mdi-cash';
                break;
            case 5:
                icon = 'mdi-email';
                break;
            case 6:
                icon = 'mdi-email-alert';
                break;
            case 7:
                icon = 'mdi-treasure-chest';
                break;
            case 8:
                icon = 'mdi-bank';
                break;
            case 50:
                icon = 'mdi-check-circle-outline';
                break;
        }
        return icon;
    },
    setTooltip(idPeriodo: number) {
        let tooltip = 'Não se aplica';
        switch (idPeriodo) {
            case 1:
                tooltip = 'Enviar Email de Confirmação de Entrega';
                break;
            case 2:
                tooltip = 'Confirmar Montagem do Processo Para Liquidação';
                break;
            case 3:
                tooltip = 'Confirmar Liquidação';
                break;
            case 4:
                tooltip = 'Confirmar Pagamento';
                break;
            case 5:
                tooltip = 'Enviar Carta de Cobrança; Start em Cobrança Administrativa';
                break;
            case 6:
                tooltip = 'Enviar Carta de Suspensão; Cobrança e Suspensão da Reposição';
                break;
            case 7:
                tooltip = 'Cobrar Reconhecimento de Dívida; Cobrança Via Advogados';
                break;
            case 8:
                tooltip = 'Processo Judicial; Formalizar Cobrança Judicial';
                break;
        }
        return tooltip;
    },
};
